// ==========================================================
// SaturnRings — Builder JS (Product Carousel + Dynamic Customization)
// ==========================================================
(function () {
    'use strict';

    var _gsap = window.gsap || { to: function () { }, fromTo: function () { } };

    // ===================== PRODUCT DATA =====================
    // Ordered: flagship ring first, then necklace, then gift products
    var PRODUCTS = [
        {
            id: 'name-ring',
            name: 'Custom Arabic Name Ring | Personalized',
            shortName: 'Name Ring',
            image: 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/Screenshot_2026-03-18_at_3.18.41_PM.png?v=1773861847',
            handle: 'stainless-steel-name-letter-ring',
            price: 38.91,
            description: 'Your name in Arabic calligraphy, sculpted in 3D and crafted in premium stainless steel. Choose your metal, finish, and size.',
            panelTitle: 'Design Your Custom Ring',
            variantMap: { 'Gold': 47701068873967, 'Rose Gold': 47701068906735, 'Silver': 47701068939503 },
            priceMap: { 'Gold': 41.39, 'Rose Gold': 41.39, 'Silver': 38.91 },
            colorImages: {
                'Gold': 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/Screenshot_2026-03-18_at_3.18.41_PM.png?v=1773861847',
                'Rose Gold': 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/Screenshot_2026-03-18_at_3.18.44_PM_c5eb0c6e-d17c-41eb-b34e-1a472ffd462a.png?v=1773861879',
                'Silver': 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/Screenshot_2026-03-18_at_3.18.36_PM_d8f73301-9440-4bef-8829-9e09898106b5.png?v=1773861896'
            },
            languageOptions: ['Arabic', 'English'],
            fontOptions: [
                { label: 'Diana',    google: 'Playfair Display',   fallback: 'serif' },
                { label: 'Maricha',  google: 'Dancing Script',     fallback: 'cursive' },
                { label: 'Adriana',  google: 'Great Vibes',        fallback: 'cursive' },
                { label: 'Christy',  google: 'Cinzel',             fallback: 'serif' },
                { label: 'Mailys',   google: 'Pacifico',           fallback: 'cursive' },
                { label: 'Fatima',   google: 'Alex Brush',         fallback: 'cursive' },
                { label: 'Camille',  google: 'Sacramento',         fallback: 'cursive' },
                { label: 'Lesley',   google: 'Lobster',            fallback: 'cursive' },
                { label: 'Audrey',   google: 'Allura',             fallback: 'cursive' },
                { label: 'Custom',   google: 'UnifrakturMaguntia', fallback: 'serif' },
                { label: 'Naisha',   google: 'Cookie',             fallback: 'cursive' },
                { label: 'Maya',     google: 'Satisfy',            fallback: 'cursive' },
                { label: 'Amelia',   google: 'Tangerine',          fallback: 'cursive' },
                { label: 'Alessia',  google: 'Cormorant Garamond', fallback: 'serif' },
                { label: 'Rachel',   google: 'Rochester',          fallback: 'cursive' },
                { label: 'Sandra',   google: 'Italianno',          fallback: 'cursive' },
                { label: 'Sophia',   google: 'Pinyon Script',      fallback: 'cursive' },
                { label: 'Anna',     google: 'Permanent Marker',   fallback: 'cursive' },
                { label: 'Tachmie',  google: 'Kaushan Script',     fallback: 'cursive' }
            ],
            fields: [
                { type: 'text', id: 'customName', label: 'Name on Ring', placeholder: 'Sara / سارة' },
                { type: 'select', id: 'ringLanguage', label: 'Language', options: ['Arabic', 'English'] },
                { type: 'select', id: 'fontStyle', label: 'Font Style', options: [], optionsDynamic: true },
                { type: 'select', id: 'metalColor', label: 'Metal Color', options: ['Gold', 'Rose Gold', 'Silver'] },
                { type: 'select', id: 'finish', label: 'Finish', options: ['Polished', 'Matte', 'Brushed'] },
                { type: 'select', id: 'ringSize', label: 'Ring Size', options: ['6', '7', '8', '9', '10', '11'] }
            ],
            getVariantId: function (vals) {
                var color = (this.fields[3].options)[vals.metalColor || 0];
                return this.variantMap[color];
            },
            getPrice: function (vals) {
                var color = (this.fields[3].options)[vals.metalColor || 0];
                return this.priceMap[color];
            },
            getProperties: function (vals) {
                var color = (this.fields[3].options)[vals.metalColor || 0];
                var finish = (this.fields[4].options)[vals.finish || 0];
                var size = (this.fields[5].options)[vals.ringSize || 3];
                var lang = this.languageOptions[vals.ringLanguage || 0];
                var fontIdx = vals.fontStyle || 0;
                var fontLabel = lang === 'English' ? this.fontOptions[fontIdx].label : 'Arabic Calligraphy';
                var displayName = vals.customName || '';
                if (lang === 'Arabic') {
                    displayName = toArabicBestEffort(displayName) || displayName;
                }
                return {
                    'Name': vals.customName || '',
                    'Display Name': displayName,
                    'Language': lang,
                    'Font Style': fontLabel,
                    'Metal Color': color,
                    'Finish': finish,
                    'Ring Size': size
                };
            },
            getSummary: function (vals) {
                var color = (this.fields[3].options)[vals.metalColor || 0];
                var finish = (this.fields[4].options)[vals.finish || 0];
                var size = (this.fields[5].options)[vals.ringSize || 3];
                return color + ' &bull; ' + finish + '<br/>Size ' + size;
            },
            getVariantImage: function (vals) {
                var color = (this.fields[3].options)[vals.metalColor || 0];
                return this.colorImages[color];
            },
            isRing: true
        },
        {
            id: 'arabic-necklace',
            name: 'Custom Arabic Name Necklace',
            shortName: 'Arabic Necklace',
            image: 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/S9015bf4b3fa34cddba5b0a20cb32d2bes.webp?v=1773863743',
            handle: 'custom-arabic-necklaces-for-women-men-personalized-stainless-steel-name-necklace-customized-couple-islamic-aesthetic-jewelry-bff',
            price: 14.64,
            description: 'Personalized stainless steel Arabic name necklace. Choose color and chain length.',
            panelTitle: 'Customize Your Arabic Necklace',
            variantMap: {
                'Silver': { '35cm for kids': 48047716139247, '40cm': 48047716434159, '45CM': 48047716204783, '50CM': 48047716172015 },
                'Rose Gold': { '35cm for kids': 48047716270319, '40cm': 48047716237551, '45CM': 48047716368623, '50CM': 48047716335855 },
                'Gold': { '35cm for kids': 48047716401391, '40cm': 48047716303087, '45CM': 48047716499695, '50CM': 48047716466927 }
            },
            priceMap: { 'Silver': 18.89, 'Rose Gold': 14.64, 'Gold': 25.64 },
            colorImages: {
                'Silver': 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/Dena.png?v=1776032367',
                'Gold': 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/S78a3692501b8438c9710ef6cef6ab626T.webp?v=1773863743',
                'Rose Gold': 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/S59d892f5921b4775b4d6e50c63513b65A.webp?v=1773863742'
            },
            getVariantImage: function (vals) {
                var color = (this.fields[1].options)[vals.metalColor || 0];
                return this.colorImages[color];
            },
            fields: [
                { type: 'text', id: 'customName', label: 'Name on Necklace', placeholder: 'e.g. Sara / سارة' },
                { type: 'select', id: 'metalColor', label: 'Metal Color', options: ['Gold', 'Silver', 'Rose Gold'] },
                { type: 'select', id: 'chainLength', label: 'Chain Length', options: ['35cm for kids', '40cm', '45CM', '50CM'] }
            ],
            getVariantId: function (vals) {
                var color = (this.fields[1].options)[vals.metalColor || 0];
                var length = (this.fields[2].options)[vals.chainLength || 0];
                return this.variantMap[color][length];
            },
            getPrice: function (vals) {
                var color = (this.fields[1].options)[vals.metalColor || 0];
                return this.priceMap[color];
            },
            getProperties: function (vals) {
                var color = (this.fields[1].options)[vals.metalColor || 0];
                var length = (this.fields[2].options)[vals.chainLength || 0];
                return {
                    'Name': vals.customName || '',
                    'Metal Color': color,
                    'Chain Length': length
                };
            },
            getSummary: function (vals) {
                var color = (this.fields[1].options)[vals.metalColor || 0];
                var length = (this.fields[2].options)[vals.chainLength || 0];
                return color + ' &bull; ' + length;
            },
            getVariantImage: function (vals) {
                var color = (this.fields[1].options)[vals.metalColor || 0];
                return this.colorImages[color];
            }
        },
        {
            id: 'music-plaque',
            name: 'Music Song Plaque LED Night Light',
            shortName: 'Music Plaque LED',
            image: 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/S6fe4f241e7964ce79e4a996d04d8b2acy.webp?v=1773863811',
            handle: 'personalized-mothers-day-gift-custom-acrylic-music-song-plaque-led-night-light-with-photo-frame-couple-anniversary-gift-decor',
            price: 25.56,
            description: 'Custom acrylic music plaque with LED light. Upload your photo, choose your song.',
            panelTitle: 'Customize Your Music Plaque',
            variants: [
                { id: 48047717155055, label: 'Custom Version C', price: 25.56, image: 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/Sca0720e091724f3ca9f0345775cc06160.webp?v=1773863810' },
                { id: 48047717187823, label: 'Couple Version', price: 25.56, image: 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/S3e1f992448564b8f8491790a91161a94E.webp?v=1773863811' },
                { id: 48047717220591, label: 'Mom Version', price: 25.56, image: 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/S373f446803674ea9ba857e5f0f8f9f5eD.webp?v=1773863811' },
                { id: 48047717253359, label: 'Custom Version G', price: 25.56, image: 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/S65429c554bea4f1ebedb7e1c5b5247e5P.webp?v=1773863811' },
                { id: 48047717286127, label: 'Dad Version', price: 25.56, image: 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/Sc340f99763694700b964643cbec668b8s.webp?v=1773863811' },
                { id: 48047717318895, label: 'Custom Version F', price: 25.56, image: 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/S967422437168471fb7b7bb116438abefe.webp?v=1773863811' },
                { id: 48047717351663, label: 'Full Screen Version', price: 25.56, image: 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/S7f56dc747c1a4c9eb7fef53a7e0405e13.webp?v=1773863810' },
                { id: 48047717384431, label: 'Custom Version E', price: 25.56, image: 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/S88e83b5daad34658834a54a02a8e245fB.webp?v=1773863811' },
                { id: 48047717417199, label: 'Multiple Images', price: 25.56, image: 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/S7d589f539037490baef23e9541a76767V.webp?v=1773863811' },
                { id: 48047717449967, label: 'Custom Version D', price: 25.56, image: 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/S12ba5aa51b3e4257ab83531456ec642ai.webp?v=1773863811' },
                { id: 48047717482735, label: 'Custom Version A', price: 25.56, image: 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/Sdd44e8c1e1ba4c7fa015b3f5652d6712Q.webp?v=1773863811' },
                { id: 48047717515503, label: 'Custom Version B', price: 25.56, image: 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/S5c2cedc26a8241bd9c80fc3701638b43j.webp?v=1773863811' }
            ],
            fields: [
                { type: 'select', id: 'version', label: 'Version / Style', optionsFrom: 'variants' },
                { type: 'text', id: 'songName', label: 'Song Name', placeholder: "e.g. Can't Help Falling in Love" },
                { type: 'text', id: 'artistName', label: 'Artist Name', placeholder: 'e.g. Elvis Presley' },
                { type: 'text', id: 'spotifyCode', label: 'Spotify Song Code', placeholder: 'Paste Spotify URI or code' },
                { type: 'upload', id: 'photo', label: 'Upload Photo', email: 'Order@saturnrings.store' }
            ],
            getVariantId: function (vals) {
                return this.variants[vals.version || 0].id;
            },
            getPrice: function (vals) {
                return this.variants[vals.version || 0].price;
            },
            getProperties: function (vals) {
                return {
                    'Song Name': vals.songName || '',
                    'Artist Name': vals.artistName || '',
                    'Spotify Code': vals.spotifyCode || '',
                    'Photo': vals._photoName || 'Will email to Order@saturnrings.store'
                };
            },
            getVariantImage: function (vals) { return this.variants[vals.version || 0].image || this.image; },
            getSummary: function (vals) {
                var v = this.variants[vals.version || 0];
                return v.label;
            }
        },
        {
            id: 'fridge-magnet',
            name: 'Music Fridge Magnet with Frame',
            shortName: 'Music Fridge Magnet',
            image: 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/Sda0b0317132b4a25952fbf6b8f521796B.webp?v=1773863809',
            handle: 'customized-photo-music-fridge-magnet-with-frame-personalized-refrigerator-magnets-best-gift-2025',
            price: 12.02,
            description: 'Custom music album fridge magnet. Add your photo, song, and artist name.',
            panelTitle: 'Customize Your Fridge Magnet',
            variants: [
                { id: 48047717089519, label: 'Style 1', price: 12.02, image: 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/Sa1d95087c11040c5bd50bd94d7ce2202j.webp?v=1773863809' },
                { id: 48047717122287, label: 'Style 2', price: 13.29, image: 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/Sda0b0317132b4a25952fbf6b8f521796B.webp?v=1773863809' }
            ],
            fields: [
                { type: 'select', id: 'style', label: 'Style', optionsFrom: 'variants' },
                { type: 'text', id: 'songName', label: 'Song Name', placeholder: 'e.g. Perfect' },
                { type: 'text', id: 'artistName', label: 'Artist Name / Singer', placeholder: 'e.g. Ed Sheeran' },
                { type: 'upload', id: 'photo', label: 'Upload Photo', email: 'Order@saturnrings.store' }
            ],
            getVariantId: function (vals) {
                return this.variants[vals.style || 0].id;
            },
            getPrice: function (vals) {
                return this.variants[vals.style || 0].price;
            },
            getProperties: function (vals) {
                return {
                    'Song Name': vals.songName || '',
                    'Artist / Singer': vals.artistName || '',
                    'Photo': vals._photoName || 'Will email to Order@saturnrings.store'
                };
            },
            getVariantImage: function (vals) { return this.variants[vals.style || 0].image || this.image; },
            getSummary: function (vals) {
                return this.variants[vals.style || 0].label;
            }
        },
        {
            id: 'pet-pillow',
            name: 'Personalized Pet Pillow (3D Print)',
            shortName: 'Pet Pillow',
            image: 'https://cdn.shopify.com/s/files/1/0802/6079/2559/files/S6efc5a004bbf40fab973128ab9793431k.webp?v=1773863809',
            handle: 'personalized-pet-pillow-with-photo-customization-plush-dog-and-cat-seat-cushion-double-sided-3d-printing',
            price: 10.82,
            description: 'Custom pet pillow with your photo. Double-sided 3D printing.',
            panelTitle: 'Customize Your Pet Pillow',
            variants: [
                { id: 48047717023983, label: '10cm', price: 10.82 },
                { id: 48047716991215, label: '20cm', price: 12.22 },
                { id: 48047716958447, label: '30cm', price: 13.06 },
                { id: 48047716925679, label: '40cm', price: 20.94 }
            ],
            fields: [
                { type: 'select', id: 'size', label: 'Pillow Size', optionsFrom: 'variants' },
                { type: 'upload', id: 'photo', label: 'Upload Pet Photo', email: 'Order@saturnrings.store' }
            ],
            getVariantId: function (vals) {
                return this.variants[vals.size || 0].id;
            },
            getPrice: function (vals) {
                return this.variants[vals.size || 0].price;
            },
            getProperties: function (vals) {
                return {
                    'Size': this.variants[vals.size || 0].label,
                    'Photo': vals._photoName || 'Will email to Order@saturnrings.store'
                };
            },
            getSummary: function (vals) {
                return this.variants[vals.size || 0].label;
            }
        }
    ];

    var PRODUCT_CARD_IMAGE_WIDTHS = [220, 320, 440];
    var PREVIEW_IMAGE_WIDTHS = [336, 448, 672];
    var PRODUCT_CARD_IMAGE_SIZES = '(max-width: 520px) 160px, (max-width: 980px) 180px, 220px';
    var PREVIEW_IMAGE_SIZES = '(max-width: 980px) calc(100vw - 84px), 448px';

    // ===================== GOOGLE FONTS LOADER =====================
    var loadedFonts = {};
    function loadGoogleFont(fontName) {
        if (loadedFonts[fontName]) return;
        loadedFonts[fontName] = true;
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://fonts.googleapis.com/css2?family=' + encodeURIComponent(fontName) + ':wght@400;700&display=swap';
        document.head.appendChild(link);
    }

    // ===================== ARABIC HELPERS =====================
    function hasArabic(s) { return /[\u0600-\u06FF]/.test(s || ''); }

    var nameExceptions = {
        'sara': 'سارة', 'sarah': 'سارة', 'mazen': 'مازن', 'mohammed': 'محمد', 'muhammad': 'محمد',
        'ali': 'علي', 'noor': 'نور', 'nour': 'نور', 'layla': 'ليلى'
    };

    var arabicMap = {
        'a': 'ا', 'b': 'ب', 'c': 'ك', 'd': 'د', 'e': 'ي', 'f': 'ف', 'g': 'ج', 'h': 'ه', 'i': 'ي', 'j': 'ج', 'k': 'ك',
        'l': 'ل', 'm': 'م', 'n': 'ن', 'o': 'و', 'p': 'ب', 'q': 'ق', 'r': 'ر', 's': 'س', 't': 'ت', 'u': 'و', 'v': 'ف',
        'w': 'و', 'x': 'كس', 'y': 'ي', 'z': 'ز', ' ': ' '
    };

    function toArabicBestEffort(input) {
        var raw = (input || '').trim();
        if (!raw) return '';
        if (hasArabic(raw)) return raw;
        var key = raw.toLowerCase();
        if (nameExceptions[key]) return nameExceptions[key];
        var out = '';
        for (var ci = 0; ci < key.length; ci++) {
            out += (arabicMap[key[ci]] || '');
        }
        return out.replace(/\s+/g, ' ').trim();
    }

    function getDefaultFieldValues(product) {
        var defaults = {};
        if (!product || !product.fields) return defaults;
        product.fields.forEach(function (field) {
            if (field.type !== 'select') return;
            defaults[field.id] = field.id === 'ringSize' ? 3 : 0;
        });
        return defaults;
    }

    function normalizeImageUrl(url) {
        return (url || '').replace(/&amp;/g, '&');
    }

    function getSizedImageUrl(url, width) {
        var normalized = normalizeImageUrl(url);
        if (!normalized) return '';
        try {
            var parsed = new URL(normalized, window.location.origin);
            parsed.searchParams.delete('width');
            parsed.searchParams.set('width', String(width));
            return parsed.toString();
        } catch (e) {
            var separator = normalized.indexOf('?') === -1 ? '?' : '&';
            return normalized.replace(/([?&])width=\d+/g, '$1').replace(/[?&]$/, '') + separator + 'width=' + width;
        }
    }

    function getResponsiveSrcSet(url, widths) {
        return widths.map(function (width) {
            return getSizedImageUrl(url, width) + ' ' + width + 'w';
        }).join(', ');
    }

    function setResponsiveImageAttributes(img, url, widths, sizes, fallbackWidth) {
        if (!img || !url) return;
        img.src = getSizedImageUrl(url, fallbackWidth || widths[0]);
        img.srcset = getResponsiveSrcSet(url, widths);
        img.sizes = sizes;
        img.decoding = 'async';
    }

    // ===================== STATE =====================
    var selectedProductIndex = 0;
    var fieldValues = getDefaultFieldValues(PRODUCTS[selectedProductIndex]);
    var hasHydratedInitialPreview = false;

    // ===================== DOM REFS =====================
    var carouselTrack = document.getElementById('sr-b-carouselTrack');
    var carouselDots = document.getElementById('sr-b-carouselDots');
    var prevBtn = document.getElementById('sr-b-prevBtn');
    var nextBtn = document.getElementById('sr-b-nextBtn');
    var formFields = document.getElementById('sr-b-formFields');
    var panelTitle = document.getElementById('sr-b-panelTitle');
    var panelDesc = document.getElementById('sr-b-panelDesc');
    var previewLabel = document.getElementById('sr-b-previewLabel');
    var priceEl = document.getElementById('sr-b-price');
    var summaryEl = document.getElementById('sr-b-summary');
    var previewImg = document.getElementById('sr-b-previewImg');
    var previewImageBox = document.getElementById('sr-b-previewImage');
    var ringStage = document.getElementById('sr-b-ringStage');
    var calligraphyEl = document.getElementById('sr-b-calligraphy');
    var checkoutBtn = document.getElementById('sr-b-checkoutBtn');
    var addToCartBtn = document.getElementById('sr-b-addToCartBtn');

    // ===================== CAROUSEL =====================
    var scrollPos = 0;

    function setPreviewLayout(isRingProduct) {
        if (previewImageBox) {
            previewImageBox.classList.toggle('sr-b-previewImage--ring', isRingProduct);
            previewImageBox.classList.toggle('sr-b-previewImage--product', !isRingProduct);
        }
        if (ringStage) {
            ringStage.hidden = !isRingProduct;
        }
    }

    function buildCarousel() {
        if (!carouselTrack) return;
        carouselTrack.innerHTML = '';
        PRODUCTS.forEach(function (p, i) {
            var card = document.createElement('div');
            card.className = 'sr-b-product-card' + (i === selectedProductIndex ? ' active' : '');
            card.setAttribute('data-index', i);
            card.innerHTML =
                '<div class="sr-b-card-img"><img src="' + getSizedImageUrl(p.image, 320) + '" srcset="' + getResponsiveSrcSet(p.image, PRODUCT_CARD_IMAGE_WIDTHS) + '" sizes="' + PRODUCT_CARD_IMAGE_SIZES + '" alt="' + p.shortName + '" loading="lazy" decoding="async" /></div>' +
                '<div class="sr-b-card-body">' +
                '<div class="sr-b-card-name">' + p.shortName + '</div>' +
                '<div class="sr-b-card-price">From $' + p.price.toFixed(2) + '</div>' +
                '<button class="sr-b-card-btn" type="button">Customize</button>' +
                '</div>';
            card.addEventListener('click', function () { selectProduct(i); });
            carouselTrack.appendChild(card);
        });

        // Build dots
        if (carouselDots) {
            carouselDots.innerHTML = '';
            PRODUCTS.forEach(function (p, i) {
                var dot = document.createElement('span');
                dot.className = 'sr-b-dot' + (i === selectedProductIndex ? ' active' : '');
                dot.addEventListener('click', function () { selectProduct(i); });
                carouselDots.appendChild(dot);
            });
        }
    }

    function scrollCarousel(dir) {
        if (!carouselTrack) return;
        var cardWidth = carouselTrack.querySelector('.sr-b-product-card');
        if (!cardWidth) return;
        var w = cardWidth.offsetWidth + 16; // gap
        var maxScroll = carouselTrack.scrollWidth - carouselTrack.parentElement.offsetWidth;
        scrollPos = Math.max(0, Math.min(scrollPos + (dir * w), maxScroll));
        carouselTrack.style.transform = 'translateX(-' + scrollPos + 'px)';
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollCarousel(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollCarousel(1); });

    // Touch/swipe support
    var touchStartX = 0;
    if (carouselTrack) {
        carouselTrack.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
        carouselTrack.addEventListener('touchend', function (e) {
            var diff = touchStartX - e.changedTouches[0].clientX;
            if (Math.abs(diff) > 40) scrollCarousel(diff > 0 ? 1 : -1);
        }, { passive: true });
    }

    // ===================== SELECT PRODUCT =====================
    function selectProduct(index) {
        var product = PRODUCTS[index];
        selectedProductIndex = index;
        fieldValues = getDefaultFieldValues(product);

        // Update active card
        var cards = carouselTrack.querySelectorAll('.sr-b-product-card');
        cards.forEach(function (c, i) { c.classList.toggle('active', i === index); });

        // Update dots
        if (carouselDots) {
            var dots = carouselDots.querySelectorAll('.sr-b-dot');
            dots.forEach(function (d, i) { d.classList.toggle('active', i === index); });
        }

        // Scroll to reveal selected card
        var selectedCard = cards[index];
        if (selectedCard) {
            var parentLeft = carouselTrack.parentElement.getBoundingClientRect().left;
            var cardLeft = selectedCard.getBoundingClientRect().left;
            var cardW = selectedCard.offsetWidth;
            var parentW = carouselTrack.parentElement.offsetWidth;
            if (cardLeft < parentLeft || (cardLeft + cardW) > (parentLeft + parentW)) {
                scrollPos = selectedCard.offsetLeft - 16;
                carouselTrack.style.transform = 'translateX(-' + scrollPos + 'px)';
            }
        }

        // Update panel
        if (panelTitle) panelTitle.textContent = product.panelTitle;
        if (panelDesc) panelDesc.textContent = product.description;
        if (previewLabel) previewLabel.textContent = product.shortName;

        // Build form fields
        buildFormFields(product);

        // Update preview
        updatePreview();

        // Animate panel in
        try {
            var panel = document.getElementById('sr-b-panel');
            if (panel) _gsap.fromTo(panel, { opacity: 0.6, y: 10 }, { opacity: 1, y: 0, duration: 0.35, ease: 'power2.out' });
        } catch (e) { }
    }

    // ===================== FORM BUILDER =====================
    function buildFormFields(product) {
        if (!formFields) return;
        formFields.innerHTML = '';

        product.fields.forEach(function (field) {
            var row = document.createElement('div');
            row.className = 'sr-b-row' + (field.type === 'info' ? ' sr-b-info-row' : '');

            if (field.type === 'info') {
                row.innerHTML =
                    '<label>' + field.label + '</label>' +
                    '<p class="sr-b-hint" style="margin:0;">' + field.text + '</p>';
            } else if (field.type === 'text') {
                var label = document.createElement('label');
                label.setAttribute('for', 'sr-bf-' + field.id);
                label.textContent = field.label;
                var input = document.createElement('input');
                input.type = 'text';
                input.id = 'sr-bf-' + field.id;
                input.placeholder = field.placeholder || '';
                input.autocomplete = 'off';
                // Restore existing value if form is being rebuilt
                if (fieldValues[field.id] !== undefined && typeof fieldValues[field.id] === 'string') {
                    input.value = fieldValues[field.id];
                }
                input.addEventListener('input', function () {
                    fieldValues[field.id] = input.value;
                    updatePreview();
                });
                row.appendChild(label);
                row.appendChild(input);

                // Set default for ring size
                if (field.id === 'ringSize') {
                    fieldValues[field.id] = 3; // default size 9
                }
            } else if (field.type === 'select') {
                var label2 = document.createElement('label');
                label2.setAttribute('for', 'sr-bf-' + field.id);
                label2.textContent = field.label;
                var select = document.createElement('select');
                select.id = 'sr-bf-' + field.id;

                var options;
                if (field.optionsFrom === 'variants') {
                    options = product.variants.map(function (v) { return v.label; });
                } else if (field.optionsDynamic && field.id === 'fontStyle') {
                    // Font options depend on language selection
                    var langIdx = fieldValues.ringLanguage || 0;
                    var lang = product.languageOptions ? product.languageOptions[langIdx] : 'Arabic';
                    if (lang === 'English' && product.fontOptions) {
                        options = product.fontOptions.map(function (f) { return f.label; });
                    } else {
                        // Arabic: hide font row entirely
                        options = ['Arabic Calligraphy'];
                        row.style.display = 'none';
                    }
                } else {
                    options = field.options || [];
                }

                options.forEach(function (opt, oi) {
                    var o = document.createElement('option');
                    o.value = oi;
                    o.textContent = opt;
                    select.appendChild(o);
                });

                // Set default / restore for selects
                if (field.id === 'ringSize' && fieldValues[field.id] === undefined) {
                    select.value = 3;
                    fieldValues[field.id] = 3;
                } else if (field.id === 'fontStyle') {
                    // Reset font style when language changes
                    fieldValues[field.id] = fieldValues[field.id] || 0;
                    select.value = fieldValues[field.id];
                } else if (fieldValues[field.id] !== undefined) {
                    // Restore previously selected value on rebuild
                    select.value = fieldValues[field.id];
                } else {
                    fieldValues[field.id] = 0;
                }

                select.addEventListener('change', function () {
                    fieldValues[field.id] = parseInt(select.value);
                    // If language changed, rebuild form to show/hide font picker
                    if (field.id === 'ringLanguage') {
                        fieldValues.fontStyle = 0;
                        buildFormFields(product);
                    }
                    updatePreview();
                });

                row.appendChild(label2);
                row.appendChild(select);
            } else if (field.type === 'upload') {
                row.className = 'sr-b-row stack';
                var label3 = document.createElement('label');
                label3.textContent = field.label;
                row.appendChild(label3);
                var uploadWrap = document.createElement('div');
                uploadWrap.style.cssText = 'display:flex;flex-direction:column;gap:8px;';
                var zone = document.createElement('div');
                zone.className = 'sr-b-uploadZone';
                zone.innerHTML = '<div class="sr-b-uploadIcon">\uD83D\uDCF7</div>' +
                    '<div class="sr-b-uploadText">Tap to upload your photo</div>' +
                    '<div class="sr-b-uploadHint">JPG, PNG \u2014 max 10MB</div>';
                var fileInput = document.createElement('input');
                fileInput.type = 'file'; fileInput.accept = 'image/*';
                fileInput.id = 'sr-bf-' + field.id;
                zone.appendChild(fileInput);
                var thumbPreview = document.createElement('div');
                thumbPreview.className = 'sr-b-uploadThumb';
                var fileNameEl = document.createElement('div');
                fileNameEl.className = 'sr-b-uploadFileName';
                fileInput.addEventListener('change', function () {
                    var file = fileInput.files[0];
                    if (file) {
                        fieldValues._photoName = file.name;
                        zone.classList.add('has-file');
                        zone.querySelector('.sr-b-uploadText').textContent = 'Uploading...';
                        zone.querySelector('.sr-b-uploadHint').textContent = 'Please wait';
                        fileNameEl.textContent = '';

                        // Show local preview
                        var reader = new FileReader();
                        reader.onload = function (e) {
                            fieldValues._photoData = e.target.result;
                            thumbPreview.innerHTML = '<img src="' + e.target.result + '" />';
                            thumbPreview.classList.add('visible');

                            // Upload to imgBB to get a shareable link
                            var base64Data = e.target.result.split(',')[1];
                            var imgForm = new FormData();
                            imgForm.append('key', '2bdfaadee7d3e254479abc937e635790');
                            imgForm.append('image', base64Data);
                            imgForm.append('name', file.name);

                            fetch('https://api.imgbb.com/1/upload', {
                                method: 'POST',
                                body: imgForm
                            }).then(function (r) { return r.json(); })
                            .then(function (data) {
                                if (data && data.data && data.data.url) {
                                    fieldValues._photoUrl = data.data.url;
                                    zone.querySelector('.sr-b-uploadText').textContent = 'Photo uploaded \u2713';
                                    zone.querySelector('.sr-b-uploadHint').textContent = 'Tap again to change';
                                    fileNameEl.textContent = '\uD83D\uDCCE ' + file.name;
                                    fileNameEl.innerHTML += '<br/><a href="' + data.data.url + '" target="_blank" style="color:rgba(255,223,156,.9);font-size:11px;">View uploaded image \u2197</a>';
                                } else {
                                    // imgBB failed — fall back to keeping the file name
                                    fieldValues._photoUrl = null;
                                    zone.querySelector('.sr-b-uploadText').textContent = 'Photo selected \u2713';
                                    zone.querySelector('.sr-b-uploadHint').textContent = 'Upload to cloud failed — will send filename';
                                    fileNameEl.textContent = '\uD83D\uDCCE ' + file.name;
                                }
                            }).catch(function () {
                                fieldValues._photoUrl = null;
                                zone.querySelector('.sr-b-uploadText').textContent = 'Photo selected \u2713';
                                zone.querySelector('.sr-b-uploadHint').textContent = 'Upload to cloud failed — will send filename';
                                fileNameEl.textContent = '\uD83D\uDCCE ' + file.name;
                            });
                        };
                        reader.readAsDataURL(file);
                    }
                });
                uploadWrap.appendChild(zone);
                uploadWrap.appendChild(thumbPreview);
                uploadWrap.appendChild(fileNameEl);
                var emailNote = document.createElement('p');
                emailNote.className = 'sr-b-hint';
                emailNote.innerHTML = '\uD83D\uDCE7 Or email your photo to <strong style="color:rgba(255,223,156,.95);">' + field.email + '</strong> with your order number.';
                uploadWrap.appendChild(emailNote);
                row.appendChild(uploadWrap);
            }

            formFields.appendChild(row);
        });

        // Add hint for ring product
        if (product.isRing) {
            var hint = document.createElement('p');
            hint.className = 'sr-b-hint';
            hint.textContent = 'Tip: write Arabic directly if you want exact spelling.';
            formFields.appendChild(hint);
        }
    }

    // ===================== PREVIEW =====================
    var typingTimer = null;

    function sparkle() {
        if (!ringStage) return;
        var s = document.createElement('span');
        s.className = 'sr-b-spark';
        var r = ringStage.getBoundingClientRect();
        var x = (Math.random() * 140) + (r.width * 0.5 - 70);
        var y = (Math.random() * 60) + (r.height * 0.5 - 30);
        s.style.left = x + 'px';
        s.style.top = y + 'px';
        s.style.opacity = '0';
        ringStage.appendChild(s);
        try {
            _gsap.to(s, { opacity: 1, duration: 0.08, ease: 'power2.out' });
            _gsap.to(s, { x: (Math.random() * 40 - 20), y: (Math.random() * 40 - 20), duration: 0.55, ease: 'power2.out' });
            _gsap.to(s, { opacity: 0, duration: 0.45, ease: 'power2.in', delay: 0.12, onComplete: function () { s.remove(); } });
        } catch (e) {
            s.style.transition = 'opacity .35s ease, transform .55s ease';
            requestAnimationFrame(function () {
                s.style.opacity = '1';
                s.style.transform = 'translate(' + (Math.random() * 40 - 20) + 'px, ' + (Math.random() * 40 - 20) + 'px)';
            });
            setTimeout(function () { s.style.opacity = '0'; }, 180);
            setTimeout(function () { s.remove(); }, 750);
        }
    }

    function typeMagic(text, shouldAnimate) {
        clearTimeout(typingTimer);
        if (!calligraphyEl) return;
        if (!shouldAnimate) {
            calligraphyEl.textContent = text;
            return;
        }
        calligraphyEl.innerHTML = '';
        var cursor = document.createElement('span');
        cursor.className = 'sr-b-magicCursor';
        var i = 0;
        function step() {
            calligraphyEl.textContent = text.slice(0, i);
            calligraphyEl.appendChild(cursor);
            sparkle();
            i += 1;
            if (i <= text.length) {
                typingTimer = setTimeout(step, 55);
            }
        }
        step();
    }

    function updatePreview() {
        if (selectedProductIndex === null) return;
        var product = PRODUCTS[selectedProductIndex];
        var price = product.getPrice ? product.getPrice(fieldValues) : product.price;

        // Price
        if (priceEl) priceEl.textContent = '$' + price.toFixed(2);

        // Summary
        if (summaryEl && product.getSummary) {
            summaryEl.innerHTML = product.getSummary(fieldValues);
        }

        if (product.isRing) {
            setPreviewLayout(true);

            var nameVal = (fieldValues.customName || '').trim();
            var langIdx = fieldValues.ringLanguage || 0;
            var lang = product.languageOptions ? product.languageOptions[langIdx] : 'Arabic';
            var shouldAnimateText = hasHydratedInitialPreview;

            if (lang === 'English') {
                // English mode: use selected Google Font
                var fontIdx = fieldValues.fontStyle || 0;
                var fontEntry = product.fontOptions[fontIdx];
                loadGoogleFont(fontEntry.google);
                var displayText = nameVal || 'Sara';
                if (calligraphyEl) {
                    calligraphyEl.style.fontFamily = '"' + fontEntry.google + '", ' + fontEntry.fallback;
                    calligraphyEl.style.direction = 'ltr';
                    // Adjust size for some fonts
                    if (fontEntry.label === 'Amelia' || fontEntry.label === 'Sandra') {
                        calligraphyEl.style.fontSize = '64px';
                    } else {
                        calligraphyEl.style.fontSize = '';
                    }
                }
                typeMagic(displayText, shouldAnimateText);
            } else {
                // Arabic mode: use Arabic calligraphy
                var ar = toArabicBestEffort(nameVal) || '\u0633\u0627\u0631\u0629';
                if (calligraphyEl) {
                    calligraphyEl.style.fontFamily = '"Doran", serif';
                    calligraphyEl.style.direction = 'rtl';
                    calligraphyEl.style.fontSize = '';
                }
                typeMagic(ar, shouldAnimateText);
            }
            if (product.getVariantImage) {
                var ringImg = product.getVariantImage(fieldValues);
                if (previewImg) {
                    setResponsiveImageAttributes(previewImg, ringImg, PREVIEW_IMAGE_WIDTHS, PREVIEW_IMAGE_SIZES, 448);
                    previewImg.alt = product.shortName;
                }
            }
        } else {
            setPreviewLayout(false);
            var varImg = product.getVariantImage ? product.getVariantImage(fieldValues) : product.image;
            if (previewImg) {
                setResponsiveImageAttributes(previewImg, varImg, PREVIEW_IMAGE_WIDTHS, PREVIEW_IMAGE_SIZES, 448);
                previewImg.alt = product.shortName;
            }
        }

        hasHydratedInitialPreview = true;
    }

    // ===================== CART DRAWER =====================
    var cartDrawer = document.getElementById('sr-b-cartDrawer');
    var cartOverlay = document.getElementById('sr-b-overlay');
    var cartToggle = document.getElementById('sr-b-cartToggle');
    var cartCloseBtn2 = document.getElementById('sr-b-cartClose');
    var cartItemsEl = document.getElementById('sr-b-cartItems');
    var cartTotalEl = document.getElementById('sr-b-cartTotal');
    var cartBadge = document.getElementById('sr-b-cartBadge');
    var goCheckoutBtn = document.getElementById('sr-b-goCheckout');

    function openCart() {
        if (cartDrawer) cartDrawer.classList.add('open');
        if (cartOverlay) cartOverlay.classList.add('open');
        refreshCart();
    }
    function closeCart() {
        if (cartDrawer) cartDrawer.classList.remove('open');
        if (cartOverlay) cartOverlay.classList.remove('open');
    }
    if (cartToggle) cartToggle.addEventListener('click', openCart);
    if (cartCloseBtn2) cartCloseBtn2.addEventListener('click', closeCart);
    if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
    if (goCheckoutBtn) goCheckoutBtn.addEventListener('click', function () { window.location.href = '/checkout'; });

    function updateCartBadge(count) {
        if (cartBadge) {
            cartBadge.textContent = count;
            cartBadge.classList.toggle('visible', count > 0);
        }
    }

    async function refreshCart() {
        if (cartItemsEl && cartDrawer && cartDrawer.classList.contains('open')) {
            cartItemsEl.innerHTML = '<div class="sr-b-cartLoading">Loading cart\u2026</div>';
        }
        try {
            var res = await fetch('/cart.js');
            var cart = await res.json();
            updateCartBadge(cart.item_count);
            if (cartTotalEl) cartTotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
            renderCartItems(cart.items);
        } catch (e) {
            if (cartItemsEl) cartItemsEl.innerHTML = '<div class="sr-b-cartEmpty">Could not load cart</div>';
        }
    }

    async function changeCartQty(key, qty, btnEl) {
        if (btnEl) btnEl.style.opacity = '.4';
        try {
            await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: qty })
            });
            refreshCart();
        } catch (e) {
            if (btnEl) btnEl.style.opacity = '1';
        }
    }

    function renderCartItems(items) {
        if (!cartItemsEl) return;
        if (!items || items.length === 0) {
            cartItemsEl.innerHTML = '<div class="sr-b-cartEmpty">Your cart is empty</div>';
            return;
        }
        var frag = document.createDocumentFragment();
        items.forEach(function (item) {
            var div = document.createElement('div');
            div.className = 'sr-b-cartItem';
            var imgSrc = item.image || '';
            if (typeof imgSrc === 'string' && imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
            div.innerHTML =
                '<img src="' + (imgSrc || '') + '" alt="' + item.title + '" loading="lazy" />' +
                '<div class="sr-b-cartItemInfo">' +
                '<div class="sr-b-cartItemName">' + item.title + '</div>' +
                '<div class="sr-b-cartItemVariant">' + (item.variant_title || '') + '</div>' +
                '<div class="sr-b-cartItemBottom">' +
                '<div class="sr-b-cartItemPrice">$' + (item.final_line_price / 100).toFixed(2) + '</div>' +
                '<div class="sr-b-cartQty">' +
                '<button class="sr-b-cartQtyBtn minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" type="button">&minus;</button>' +
                '<span class="sr-b-cartQtyVal">' + item.quantity + '</span>' +
                '<button class="sr-b-cartQtyBtn plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" type="button">&plus;</button>' +
                '</div>' +
                '</div>' +
                '<button class="sr-b-cartRemoveBtn" data-key="' + item.key + '" type="button">Remove</button>' +
                '</div>';
            frag.appendChild(div);
        });
        cartItemsEl.innerHTML = '';
        cartItemsEl.appendChild(frag);
        cartItemsEl.querySelectorAll('.sr-b-cartQtyBtn').forEach(function (btn) {
            btn.addEventListener('click', function () {
                changeCartQty(btn.getAttribute('data-key'), parseInt(btn.getAttribute('data-qty')), btn);
            });
        });
        cartItemsEl.querySelectorAll('.sr-b-cartRemoveBtn').forEach(function (btn) {
            btn.addEventListener('click', function () {
                changeCartQty(btn.getAttribute('data-key'), 0, btn);
            });
        });
    }

    // ===================== ADD TO CART =====================
    async function addItemToCart(redirectTo) {
        if (selectedProductIndex === null) {
            alert('Please select a product first.');
            return;
        }

        var product = PRODUCTS[selectedProductIndex];
        var variantId = product.getVariantId(fieldValues);
        var properties = product.getProperties ? product.getProperties(fieldValues) : {};

        if (product.isRing || product.id === 'arabic-necklace') {
            var nameField = fieldValues.customName;
            if (!nameField || !nameField.trim()) {
                alert('Please enter a name for your ' + (product.isRing ? 'ring' : 'necklace') + '.');
                var nameInput = document.getElementById('sr-bf-customName');
                if (nameInput) nameInput.focus();
                return;
            }
        }

        var btn = redirectTo === '/checkout' ? checkoutBtn : addToCartBtn;
        var originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding...';

        // If a photo was uploaded, use the imgBB URL link (or filename as fallback)
        if (fieldValues._photoUrl) {
            properties['Photo'] = fieldValues._photoUrl;
        } else if (fieldValues._photoName) {
            properties['Photo'] = fieldValues._photoName;
        }

        try {
            var res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity: 1,
                        properties: properties
                    }]
                })
            });

            if (!res.ok) {
                var errData = {};
                try { errData = await res.json(); } catch (e) { }
                throw new Error(errData.description || errData.message || 'Could not add to cart');
            }

            if (redirectTo) {
                btn.textContent = 'Redirecting...';
                window.location.href = redirectTo;
            } else {
                btn.textContent = 'Added \u2713';
                try { _gsap.fromTo(btn, { scale: 1 }, { scale: 1.05, duration: 0.12, yoyo: true, repeat: 1 }); } catch (e) { }
                setTimeout(function () {
                    btn.textContent = originalText;
                    btn.disabled = false;
                }, 1500);
                openCart();
            }

        } catch (e) {
            btn.disabled = false;
            btn.textContent = originalText;
            alert('Could not add to cart: ' + (e.message || 'Unknown error') + '. Please try again.');
        }
    }

    if (checkoutBtn) {
        checkoutBtn.addEventListener('click', function () { addItemToCart('/checkout'); });
    }

    if (addToCartBtn) {
        addToCartBtn.addEventListener('click', function () { addItemToCart(null); });
    }

    // ===================== INIT =====================
    buildCarousel();
    if (selectedProductIndex !== null) {
        var initialProduct = PRODUCTS[selectedProductIndex];
        if (panelTitle) panelTitle.textContent = initialProduct.panelTitle;
        if (panelDesc) panelDesc.textContent = initialProduct.description;
        if (previewLabel) previewLabel.textContent = initialProduct.shortName;
        buildFormFields(initialProduct);
        updatePreview();
    }
    refreshCart();

})();
